import { Gift, Play, Timer } from "lucide-react";

import fallback_img from "./img/fallback_img.jpg"

import loading_img from "./img/loadingImg.jpg"
import { useEffect, useState } from "react";
const CoursePageLeftCard =({coursePageObject})=>{
  const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border,paddingLeft,paddingRight}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  
     
          const [reloadItems, setReloadItems] = useState(true);
         
             useEffect(()=>{
                 setReloadItems(false); setReloadItems(true);
                 
             },[ ])

               
  return (
    <div style={{ position: "relative",boxShadow:boxShadow,
    overflow: "hidden",aspectRatio: aspectRatio,padding:"0px",border:border, 
     borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
    width:`${width}%`}}  className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}>
      {!isLoaded && !hasError && (
        <div
         style={
             { 
              borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
      aspectRatio: aspectRatio,
      objectFit: "cover",  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
        >
          <img
        src={loading_img}
        alt=""
      
       style={
             {
             borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
                position: "absolute",border:border,
      top: 0,
      left: 0,
      width: `${width}%`,padding:"10px",
    
      objectFit: "cover", aspectRatio: aspectRatio,  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
        </div>
      )}
      
      <img

      
        src={hasError ? fallback_img : src}
        alt=""
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
       style={
             {
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
     
      objectFit: "cover",aspectRatio: aspectRatio  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
    
    </div>
  );
};
    return(<>
     <div>
        <div   style={{width:"100px",height:"60px",
        position:"absolute",
        zIndex:"9999", top:"100px",left:"37%",textAlign:"center" ,cursor:"pointer"
        ,background:`${coursePageObject?.playerButton?.bgColor?.color}`,
border:` ${coursePageObject?.playerButton?.border?.borderWidth?.value+coursePageObject?.playerButton?.border?.borderWidth?.resolution} ${coursePageObject?.playerButton?.border?.borderType}  ${coursePageObject?.playerButton?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.playerButton?.borderRadius?.topLeft?.value}${coursePageObject?.playerButton?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.playerButton?.borderRadius?.topRight?.value}${coursePageObject?.playerButton?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.playerButton?.borderRadius?.bottomLeft?.value}${coursePageObject?.playerButton?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.playerButton?.borderRadius?.bottomRight?.value}${coursePageObject?.playerButton?.borderRadius?.bottomRight?.resolution}`,
        
        }}>
          <Play strokeWidth={3}  size={35}style={{margin:"13px"}}  color={coursePageObject?.playerButton?.iconColor?.color}/>
        </div>
        <div  style={{cursor:"pointer"}}  className="product-tag-themeCoursePage coursePageTagsFont">Trending </div>
<div  style={{cursor:"pointer",width:"100%",cursor:"pointer",marginTop:"-40px"
    
   }}>
<ImageFallFB  boxShadow={``}
                  src={coursePageObject?.imageThumbnail?.src}
                  border={coursePageObject?.imageThumbnail?.border?.borderWidth?.value+coursePageObject?.imageThumbnail?.border?.borderWidth?.resolution+" "+coursePageObject?.imageThumbnail?.border?.borderType +" "+coursePageObject?.imageThumbnail?.border?.borderColor?.color}
                  width={ 100
                  }
                  aspectRatio={coursePageObject?.imageThumbnail?.aspectRatio?.value}
                  borderRadius={ coursePageObject?.imageThumbnail?.borderRadius
                  }/>
</div>

{/* const [freePaidStatus, setFreePaidStatus] =useState(courseData?.CoursePriceType)
const [CoursePublicNoEnrollment, setCoursePublicNoEnrollment] =useState(courseData?.CoursePublicNoEnrollment)
const [salePrice, setSalePrice] =useState(courseData?.salePrice)
const [regularPrice, setRegularPrice] =useState(courseData?.regularPrice) */}
<div style={{cursor:"pointer",padding:"5px",}} >{true?
<div className="themeCoursePage" style={{display: "flex",padding:"5px",marginTop:"5px",
    flexDirection: "row",background:`${coursePageObject?.priceCard?.bgColor?.color}`,
border:` ${coursePageObject?.priceCard?.border?.borderWidth?.value+coursePageObject?.priceCard?.border?.borderWidth?.resolution} ${coursePageObject?.priceCard?.border?.borderType}  ${coursePageObject?.priceCard?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.priceCard?.borderRadius?.topLeft?.value}${coursePageObject?.priceCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.priceCard?.borderRadius?.topRight?.value}${coursePageObject?.priceCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.priceCard?.borderRadius?.bottomLeft?.value}${coursePageObject?.priceCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.priceCard?.borderRadius?.bottomRight?.value}${coursePageObject?.priceCard?.borderRadius?.bottomRight?.resolution}`,
        
     }}>
<div className="themeCoursePage coursePageTitleFont" style={{fontSize:"35px",color:coursePageObject?.priceCard?.textColor?.color}}> ₹499.00</div>
<div className="themeCoursePage strikethrough coursePageSubTitleFont" style={{fontSize:"18px",color:coursePageObject?.priceCard?.subTextColor?.color}}>
   ₹1499.00 </div>
   <div className="themeCoursePage" style={{fontSize:"13px",color:"#777",marginRight:"15px",float:"right"}}>
    </div>

</div>:<div className="themeCoursePage" >
<div className="themeCoursePage coursePageTitleFont " style={{fontSize:"28px",color:coursePageObject?.priceCard?.textColor?.color}}>  Free</div>
</div>}
</div>

{
  //for mobile Bottom Card
}
<div  className="BottomCardXsCourse"><div  className="BottomCardXsCourseInn">
{true?
<div className="themeCoursePage" style={{padding:"5px",background:`${coursePageObject?.priceCard?.bgColor?.color}`,
border:` ${coursePageObject?.priceCard?.border?.borderWidth?.value+coursePageObject?.priceCard?.border?.borderWidth?.resolution} ${coursePageObject?.priceCard?.border?.borderType}  ${coursePageObject?.priceCard?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.priceCard?.borderRadius?.topLeft?.value}${coursePageObject?.priceCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.priceCard?.borderRadius?.topRight?.value}${coursePageObject?.priceCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.priceCard?.borderRadius?.bottomLeft?.value}${coursePageObject?.priceCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.priceCard?.borderRadius?.bottomRight?.value}${coursePageObject?.priceCard?.borderRadius?.bottomRight?.resolution}`,
        
     }}>
<div className="themeCoursePage coursePageTitleFont" style={{fontSize:"26px",color:coursePageObject?.priceCard?.textColor?.color}}> ₹499.00</div>
<div className="themeCoursePage strikethrough coursePageSubTitleFont" style={{fontSize:"14px",color:coursePageObject?.priceCard?.subTextColor?.color,marginTop:"-8px"}}>
   ₹1499.00 </div>
   
</div>:<div className="themeCoursePage" >
<div className="themeCoursePage coursePageTitleFont" style={{fontSize:"28px",color:coursePageObject?.priceCard?.textColor?.color}}>  Free</div>
</div>}
{true?
<div className="themeCoursePage"  style={{fontSize:"22px",color:"#fff",
 borderRadius:"5px",margin:"13px",textAlign:"center",height:"29px",background:`${coursePageObject?.secondaryButton?.bgColor?.color}`,
border:` ${coursePageObject?.secondaryButton?.border?.borderWidth?.value+coursePageObject?.secondaryButton?.border?.borderWidth?.resolution} ${coursePageObject?.secondaryButton?.border?.borderType}  ${coursePageObject?.secondaryButton?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.secondaryButton?.borderRadius?.topLeft?.value}${coursePageObject?.secondaryButton?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.secondaryButton?.borderRadius?.topRight?.value}${coursePageObject?.secondaryButton?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.secondaryButton?.borderRadius?.bottomLeft?.value}${coursePageObject?.secondaryButton?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.secondaryButton?.borderRadius?.bottomRight?.value}${coursePageObject?.secondaryButton?.borderRadius?.bottomRight?.resolution}`,
 }}>
  <div className="themeCoursePage coursePageButtonFont"  style={{margin:"0px",color:coursePageObject?.secondaryButton?.textColor?.color}}>Buy Now</div></div>
  // :courseData?.CoursePublicNoEnrollment=="Yes"?
  // <div className="themeCoursePage"  style={{fontSize:"22px",color:"#fff",border:"1px solid #958FDA",
  //   borderRadius:"5px",margin:"13px",textAlign:"center",height:"29px",background:"#958FDA"}}>
  //    <div className="themeCoursePage"  style={{margin:"0px"}}>Start Now</div></div>:
  //    <div className="themeCoursePage"  style={{fontSize:"22px",color:"#fff",border:"1px solid #958FDA",
  //   borderRadius:"5px",margin:"13px",textAlign:"center",height:"29px",background:"#958FDA"}}>
  //    <div className="themeCoursePage"  style={{margin:"0px"}}>Enrol Now</div></div>
     :""}
  </div></div>

<div >
   {/* {courseData?.CoursePriceType=="Free"&&courseData?.CoursePublicNoEnrollment=="Yes"? <span className="themeCoursePage"
      style={{fontSize:"10px",color:"rgba(255,114,94,0.9)",display: "flex",
    flexDirection: "row"}}><Timer  size={22} color="rgba(255,114,94,0.9)"/> 
   <span className="themeCoursePage">No Enrollment Required</span></span> :""} */}
 
     {true? <div className=""
      style={{fontSize:"14px",paddingLeft:"10px",paddingTop:"10px",margin:"10px",
        background:`${coursePageObject?.priceValidityCard?.bgColor?.color}`,
border:` ${coursePageObject?.priceValidityCard?.border?.borderWidth?.value+coursePageObject?.priceValidityCard?.border?.borderWidth?.resolution} ${coursePageObject?.priceValidityCard?.border?.borderType}  ${coursePageObject?.priceValidityCard?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.priceValidityCard?.borderRadius?.topLeft?.value}${coursePageObject?.priceValidityCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.priceValidityCard?.borderRadius?.topRight?.value}${coursePageObject?.priceValidityCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.priceValidityCard?.borderRadius?.bottomLeft?.value}${coursePageObject?.priceValidityCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.priceValidityCard?.borderRadius?.bottomRight?.value}${coursePageObject?.priceValidityCard?.borderRadius?.bottomRight?.resolution}`,
        display: "flex",
    flexDirection: "row"}}><Timer  size={22} color={coursePageObject?.priceValidityCard?.iconColor?.color}/> 
   <span className="themeCoursePage coursePageSubTitleFont" style={{color:coursePageObject?.priceValidityCard?.textColor?.color,}}> Course Validity:Lifetime</span></div> :""}
 
  </div>
  {true?<div><div className="themeCoursePage "  style={{
 borderRadius:"5px",margin:"13px",textAlign:"center",height:"20px", background:`${coursePageObject?.primaryButton?.bgColor?.color}`,
border:` ${coursePageObject?.primaryButton?.border?.borderWidth?.value+coursePageObject?.primaryButton?.border?.borderWidth?.resolution} ${coursePageObject?.primaryButton?.border?.borderType}  ${coursePageObject?.primaryButton?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.primaryButton?.borderRadius?.topLeft?.value}${coursePageObject?.primaryButton?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.primaryButton?.borderRadius?.topRight?.value}${coursePageObject?.primaryButton?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.primaryButton?.borderRadius?.bottomLeft?.value}${coursePageObject?.primaryButton?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.primaryButton?.borderRadius?.bottomRight?.value}${coursePageObject?.primaryButton?.borderRadius?.bottomRight?.resolution}`,
    }}>
  <div className="themeCoursePage coursePageButtonFont"  style={{margin:"0px",fontSize:"16px",color:coursePageObject?.primaryButton?.textColor?.color,}}>Add To Cart</div></div>
  <div className="themeCoursePage"  style={{fontSize:"16px",color:"#fff",
 borderRadius:"5px",margin:"13px",textAlign:"center",height:"20px",background:`${coursePageObject?.secondaryButton?.bgColor?.color}`,
border:` ${coursePageObject?.secondaryButton?.border?.borderWidth?.value+coursePageObject?.secondaryButton?.border?.borderWidth?.resolution} ${coursePageObject?.secondaryButton?.border?.borderType}  ${coursePageObject?.secondaryButton?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.secondaryButton?.borderRadius?.topLeft?.value}${coursePageObject?.secondaryButton?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.secondaryButton?.borderRadius?.topRight?.value}${coursePageObject?.secondaryButton?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.secondaryButton?.borderRadius?.bottomLeft?.value}${coursePageObject?.secondaryButton?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.secondaryButton?.borderRadius?.bottomRight?.value}${coursePageObject?.secondaryButton?.borderRadius?.bottomRight?.resolution}`,
   }}>
  <div className="themeCoursePage coursePageButtonFont"  style={{margin:"0px",color:coursePageObject?.secondaryButton?.textColor?.color,}}>Buy Now</div></div></div>
//   :courseData?.CoursePublicNoEnrollment=="Yes"?
//   <div className="themeCoursePage"  style={{fontSize:"16px",color:"#958FDA",border:"1px solid #958FDA",
//     borderRadius:"5px",margin:"13px",textAlign:"center",height:"20px"}}>
//      <div className="themeCoursePage"  style={{margin:"0px"}}>Start Now</div></div>:<div className="themeCoursePage"  style={{fontSize:"16px",color:"#fff",border:"1px solid #958FDA",
//  borderRadius:"5px",margin:"13px",textAlign:"center",height:"20px",background:"#958FDA"}}>
//   <div className="themeCoursePage"  style={{margin:"0px"}}>Enrol Now</div></div>
  :""}

  <div className="themeCoursePage grid2080CoursePage"  style={{
  
 borderRadius:"25px",margin:"13px",marginTop:"30px",height:"44px",background:`${coursePageObject?.giftCourse?.bgColor?.color}`,
border:` ${coursePageObject?.giftCourse?.border?.borderWidth?.value+coursePageObject?.giftCourse?.border?.borderWidth?.resolution} ${coursePageObject?.giftCourse?.border?.borderType}  ${coursePageObject?.giftCourse?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.giftCourse?.borderRadius?.topLeft?.value}${coursePageObject?.giftCourse?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.giftCourse?.borderRadius?.topRight?.value}${coursePageObject?.giftCourse?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.giftCourse?.borderRadius?.bottomLeft?.value}${coursePageObject?.giftCourse?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.giftCourse?.borderRadius?.bottomRight?.value}${coursePageObject?.giftCourse?.borderRadius?.bottomRight?.resolution}`,
 }}>
  <div style={{background:`${coursePageObject?.giftCourse?.iconBgColor?.color}`,width:"50px",height:"50px",borderRadius:"50%",padding:"0px"}} >
  <Gift strokeWidth={2} absoluteStrokeWidth  size={27} style={{margin:"11px"}} color={coursePageObject?.giftCourse?.iconColor?.color} />  </div>
  <div   >
    <div className="themeCoursePage coursePageTitleFont"   style={{margin:"0px",fontSize:"16px",color:coursePageObject?.giftCourse?.textColor?.color}}>Gift this course</div>
  <div className="themeCoursePage  coursePageSubTitleFont"  style={{marginTop:"-13px",fontSize:"12px",color:coursePageObject?.giftCourse?.subTextColor?.color,fontWeight:"500"}}
  >Send this course as  gift to your friends</div></div></div>
<div style={{padding:"10px"}}>

   


</div>

</div>
    </>)
}
export default CoursePageLeftCard;